export const reducer = (state, action) => {
    return { minaylaURL: 'https://minayla.com/' }
}


// WEBPACK FOOTER //
// ./src/store/InitialStore.js